<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/o', this.organization()?.id]}]"></app-logo-area>
<main>
  <app-headline-section [title]="'Search'"></app-headline-section>
  <app-filter-section [openByDefault]="true" [filtered]="searchResults.items" [formGroup]="filters">
    <form [formGroup]="filters" class="cl-form">
      <div class="row ">
        <div class="col-12">
          <input type="text" style="width: 100%" formControlName="t"
            placeholder="" autofocus>
          <p class="valid-feedback">Search terms are case-insensitive.</p>
        </div>
        <div class="col-12">
          <input type="text" style="width: 100%" formControlName="p"
            placeholder="">
          <p class="valid-feedback">Only results with this parent ID</p>
        </div>

      </div>
      <div class="row ">
        <div class="col-3">
          <select style="width: 100%" formControlName="r" class="form-select">
            <option value="">All</option>
            @for (s of storageRoots(); track s.id) {
              <option [value]="s.id">{{ s.name }}</option>
            }
          </select>
          @if (rootsError()) {
            <p class="invalid-feedback d-block" role="alert">Could not load the storage roots: {{ rootsError() }}</p>
          } @else {
            <p class="valid-feedback">Select a storage root to search.</p>
          }
        </div>
        <div class="col-3">
          <select style="width: 100%" formControlName="sd" class="form-select">
            <option [value]="''">Current files only</option>
            <option value="true">Show deleted</option>
          </select>
          <p class="valid-feedback">Select including deletion status.</p>
        </div>
        <div class="col-3">
          <input type="datetime-local" style="width: 100%" formControlName="d1">
          <p class="valid-feedback">No files older than</p>
        </div>
        <div class="col-3">
          <input type="datetime-local" style="width: 100%" formControlName="d2">
          <p class="valid-feedback">No files younger than</p>
        </div>

      </div>

    </form>

  </app-filter-section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          @if (searchResults.items.length < searchResults.total) {
            <p class="alert cl-alert-warning"
            role="alert">{{ searchResults.items.length }} of {{ searchResults.total }} shown</p>
          }
        </div>

        <div class="col-12">
          <div class="cl-table-scroll">
            <table class="cl-table-data">
            <thead>
              <tr>
                <th class="cl-table-head">
                  <div>
                    Type
                  </div>
                </th>
                <th class="cl-table-head">
                  <div>
                    File or folder name
                  </div>
                </th>
                <th class="cl-table-head">
                  <div>
                    Last Modified
                  </div>
                </th>
              </tr>
            </thead>
            @if (searchState.loading || searchState.error) {
              <tbody>
                <tr appLoadRow [state]="searchState" thing="search results"></tr>
              </tbody>

            } @else {
              @if (searchResults.items.length === 0) {
                <tbody>
                  <tr class="cl-tr-no-data">
                    <td colspan="100">No data available.</td>
                  </tr>
                </tbody>

              } @else {
                <tbody>
                  @for (it of searchResults.items; track it) {
                    <tr>
                      <td>
                        <app-asset-icon [thing]="it.item"></app-asset-icon>
                      </td>
                      <td [class.cl-faded]="it.item.deleted">
                        <a [routerLink]=" it.item | link"
                          (click)="$event.stopPropagation()">
                          {{
                          it.item.id | remove:"s3://content-repo-.*-contentsupplier-" | orgResolver | middleTruncate: 100
                          }}
                        </a>
                      </td>
                      <td class="cl-td-time" style="white-space: nowrap">
                        <app-date [value]="it.item.last_modified" />
                      </td>
                    </tr>
                  }
                </tbody>
              }
            }


          </table>
          </div>
      </div>
    </div>
  </div>
</section>
</main>
